export default (state = {}, action) => {
	return state;
};



// WEBPACK FOOTER //
// ./client/reducers/app.js